import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  max-width: 380px;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 2px;

  > h3 {
    font-family: 'Bebas Neue', sans-serif;
    margin-bottom: 8px;
  }
`;

export const Label = styled.label`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;

  img {
    width: 100%;
    max-width: 128px;
  }

  input {
    display: none;
  }
`;

export const GroupButton = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 8px;

  span {
    width: 100%;
    margin-top: -4px;
    font-size: 12px;
    text-align: center;
  }
`;

export const Button = styled.div`
  width: 100%;
  color: ${({ theme }) => theme.colors.grey.white};
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  margin-top: ${({ $top }) => ($top ? `${$top}px` : '0px')};
  padding: ${({ $padding }) => ($padding ? `${$padding}px` : '0px')};
  border: 0;
  z-index: 0;

  h4 {
    margin-bottom: -2px;

    @media ${({ theme }) => theme.devices.mobile} {
      font-size: 20px;
    }
  }

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: ${({ $radius }) => ($radius ? `${$radius}px` : '0px')};
    background: ${({ theme }) => theme.colors.gradient.fullX};
    opacity: ${({ $active }) => ($active ? `1` : '0.3')};
    z-index: -2;
  }

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: ${({ $radius }) => ($radius ? `${$radius}px` : '0px')};
    padding: 2px;
    background: ${({ theme }) => theme.colors.gradient.fullX};
    -webkit-mask: linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    z-index: -1;
  }

  &[disabled] {
    transition: 0.7s;
    opacity: 0.5;
    cursor: default;
  }

  &:hover {
    &[disabled] {
      &::before {
        opacity: 0.3;
      }
    }

    &::before {
      transition: 0.7s;
      opacity: 1;
    }
  }
`;

export const GroupImg = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin: 12px 0;
  gap: 20px;

  a {
    display: flex;
    gap: 4px;

    color: ${({ theme }) => theme.colors.grey.white};
    padding: 4px 8px;
    margin: 0 8px;

    &:hover {
      transition: 0.7s;

      color: ${({ theme }) => theme.colors.grey[200]};
    }
  }

  img {
    width: 100%;
    object-fit: cover;
    background-color: ${({ theme }) => theme.colors.grey.white};
  }

  video {
    width: 100%;
    max-width: 220px;
    border-radius: 8px;
  }

  .profile {
    max-width: 160px;
    height: 160px;
    border-radius: 100%;
  }

  .banner {
    max-width: 260px;
    height: 160px;
    border-radius: 8px;
  }
`;

export const Error = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 4px;

  svg {
    width: 20px;
    color: ${({ theme }) => theme.colors.outher.danger};
  }

  span {
    color: ${({ theme }) => theme.colors.outher.danger};
    margin-bottom: -2px;
  }
`;

export const WrapUpload = styled.div`
  width: fit-content;
  margin-top: -4px;
  position: relative;

  button {
    z-index: 2;
    position: absolute;
    top: 0;
    right: 0;
    padding: 8px;
    background-color: ${({ theme }) => theme.colors.grey[500]};
    transform: translateX(25%) translateY(-25%);
    border: 0;
    border-radius: 100%;

    svg {
      transform: rotate(45deg);
      color: ${({ theme }) => theme.colors.grey.white};
      margin-bottom: -4px;
    }

    &:hover {
      transition: 0.7s;
      background-color: ${({ theme }) => theme.colors.grey[600]};
    }
  }

  img {
    border-radius: 8px;
    width: 100%;
    max-width: 340px;
    height: 100%;
  }

  video {
    border-radius: 8px;
    width: 100%;
    max-width: 200px;
  }
`;
